import Scrollbar from './Scrollbar';

/* istanbul ignore next */
Scrollbar.install = function(Vue) {
  Vue.component(Scrollbar.name, Scrollbar);
};

export { Scrollbar };
export default Scrollbar;
